import NoteService from '../../api/notes';
// initial state
const state = {
  noteList: [],
  noteCountsByScan: [],
  currentNote: null,
};

const getters = {
  noteList: (state) => {
    return state.noteList.sort(
      (a, b) => new Date(b.updated_date) - new Date(a.updated_date)
    );
  },
  noteCountsByScan: (state) => {
    return state.noteCountsByScan;
  },
  currentNote: (state) => {
    return state.currentNote;
  },
};

const actions = {
  async getNoteList({ commit }, payload) {
    let noteService = new NoteService();
    const response = await noteService.getNotes(payload);
    if (response && response.success) {
      commit('setNoteList', response.data);
    }
  },
  async getNoteCountsByScan({ commit }, payload) {
    let noteService = new NoteService();
    const response = await noteService.getNoteCountsByScan(payload);
    if (response && response.success) {
      commit('setNoteCountsByScan', response.data);
    }
  },
  async addNote({ commit }, payload) {
    commit('setCurrentNote', payload);
  },
  setCurrentNote({ commit }, payload) {
    commit('setCurrentNote', payload);
  },
  async deleteNote({ commit, state, dispatch }) {
    let noteService = new NoteService();
    const response = await noteService.deleteNote(state.currentNote.id);
    if (response && response.success) {
      dispatch('getNoteList', {
        scan_id: state.currentNote.scan_id,
        user_id: state.currentNote.user_id,
      });
      commit('setCurrentNote', null);
      return true;
    } else {
      return false;
    }
  },
  async deleteAllNotesByScan({ dispatch }, payload) {
    let noteService = new NoteService();
    const response = await noteService.deleteAllNotesByScan(payload);
    if (response && response.success) {
      dispatch('getNoteList', {
        scan_id: payload.scan_id,
        user_id: payload.user_id,
      });
      return true;
    } else {
      return false;
    }
  },
  async deleteUserNotesByScan({ dispatch }, payload) {
    let noteService = new NoteService();
    const response = await noteService.deleteUserNotesByScan(payload);
    if (response && response.success) {
      dispatch('getNoteList', {
        scan_id: payload.scan_id,
        user_id: payload.user_id,
      });
      return true;
    } else {
      return false;
    }
  },
  async updateNote({ dispatch, state }, payload) {
    let noteService = new NoteService();
    const response = await noteService.addNote(payload);
    if (response && response.success) {
      dispatch('getNoteList', {
        scan_id: state.currentNote.scan_id,
        user_id: state.currentNote.user_id,
      });
      return true;
    } else {
      return false;
    }
  },
  clearStore({ commit }) {
    commit('setNoteList', []);
    commit('setCurrentNote', null);
  },
};

// mutations
const mutations = {
  setNoteList(state, payload) {
    state.noteList = payload;
  },
  setNoteCountsByScan(state, payload) {
    state.noteCountsByScan = payload;
  },
  setCurrentNote(state, payload) {
    state.currentNote = payload;
  },
  addToNoteList(state, payload) {
    state.noteList.push(payload);
  },
  removeFromNoteList(state, payload) {
    state.noteList.splice(payload, 1);
  },
  updateNoteList(state, payload) {
    state.noteList.splice(payload.index, 1, payload.note);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
